import * as types from 'store/modules/warningmsg/mutation-types'
import warningmsg from 'api/warningmsg'
import swal from 'sweetalert'

export default {
  state: {
    warningmsg: []
  },
  getters: {
    [types.GET_WARNINGMSG] (state) {
      return state.warningmsg
    }
  },
  mutations: {
    [types.SET_WARNINGMSG] (state, warningmsg) {
      state.warningmsg = warningmsg
    }
  },
  actions: {
    [types.RECEIVED_WARNINGMSG] ({ commit }) {
      warningmsg.getWarningmsg()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_WARNINGMSG, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve warningmsg again', message)
          warningmsg.getWarningmsg()
            .then((response) => {
              const data2 = JSON.parse(response.request.response)
              commit(types.SET_WARNINGMSG, data2)
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/warningmsg/index.js